<div class="clock" [style.background-image]="'url(./assets/images/nc179450.png)' | safe: 'style' ">
  <span class="number"><ng-container *ngIf="hour">{{hour}}:</ng-container>{{minute}}:{{second}}</span>
</div>
